import { PlusOutlined } from '@ant-design/icons';
import { Modal, Upload } from 'antd';
import React from 'react';
import { Form } from "antd";

const CustomUploadImage = ({name , message, isRequired }) => {

  const normFile = e => {
    if (Array.isArray(e)) {
      return e;
    }
    return e &&  e.fileList;
  };

 
  const uploadButton = (
    <div>
      <PlusOutlined />
      <div
        style={{
          width : "100%"
        }}
      >
        {message}
      </div>
    </div>
  );
  return (
    <>
     <Form.Item
            name={name}
            rules={[
                {
                    required: isRequired ? true : false,
                    message: message,
                },
            ]}
            valuePropName="fileList"
            getValueFromEvent={normFile}
            className="upload-input"
        >
      <Upload
          name={name}
          listType="picture-card"
          // onPreview={handlePreview}
          maxCount={1}
          beforeUpload={()=> {
            /* update state here */
            return false; }}
        >
         { uploadButton}
        </Upload>
      </Form.Item>
    </>
  
  );
};

export default CustomUploadImage;